import { largeTabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import styled, { css } from 'styled-components';

const CONTROL_RIGHT_SPACE = 10;
const CONTROL_PADDING = 4;

export const ControlsContainer = styled.div<{ $typePosition?: 'top-right' | 'bottom-center' }>`
  position: absolute;
  top: ${({ $typePosition }) => ($typePosition === 'bottom-center' ? '5px' : '80px')};
  right: ${CONTROL_RIGHT_SPACE - CONTROL_PADDING}px;
  z-index: 1;
`;

export const DrawControls = styled.div`
  padding: 5px ${CONTROL_PADDING}px;
  border-radius: 8px;
  width: 52px;

  & button:last-child {
    margin-bottom: 0;
  }
`;

export const Control = styled.button<{ $active?: boolean }>`
  background-color: ${({ theme }) => theme.white};
  width: 44px;
  height: 44px;
  margin-bottom: 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: 300ms all;
  border-radius: 4px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  color: ${({ theme }) => theme.textDark};

  &:hover {
    background-color: ${({ theme }) => theme.backgroundLighter};
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background-color: ${theme.primary};
      color: ${theme.white};

      &:hover {
        background-color: ${theme.primary};
      }
    `}
`;

export const TypeContainer = styled.div<{ $position?: 'top-right' | 'bottom-center' }>`
  position: absolute;
  z-index: 1;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
  border-radius: 32px;

  ${({ $position }) =>
    $position === 'bottom-center'
      ? css`
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
        `
      : css`
          top: 10px;
          right: 10px;
        `}
`;

export const SavedSearchButton = styled.button<{ disableSaveSearch?: boolean }>`
  width: 200px;
  background-color: ${(props) => props.theme.primary};
  height: 44px;
  text-align: center;
  font-weight: 600;
  border-radius: 40px;
  color: ${(props) => props.theme.white};
  font-size: 16px;
  position: fixed;
  bottom: 30px;
  left: 10px;
  z-index: 4;

  ${(props) =>
    props.disableSaveSearch &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `}

  svg {
    margin-right: 10px;
  }

  @media (${largeTabletMax}) {
    bottom: ${platform.select('85px', '30px')};
  }
`;

export const ZoomControls = styled.div`
  display: none;
  padding: 5px 4px;
  margin-bottom: 15px;

  & button:last-child {
    margin-bottom: 0;
  }

  // only shows if mouse is detected
  @media (pointer: fine) {
    display: block;
  }
`;
